// extracted by mini-css-extract-plugin
export default {"progressCircle":"IssueItemSubIssuesSummary-module__progressCircle--iCRm9"};